import styled from "@emotion/styled";

export const Italic = styled.div`
  font-size: 18px;
  font-style: italic;
  font-family: Cormorant_Infant;
`;
